import { createRouter, createWebHistory } from 'vue-router'
import {useAuthStore} from "@/store/useAuthStore";
import {ROUTES_EQUIVALENT_PERM_CODE, ROUTES_PARENT} from "@/config/constants";

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/LoginPage.vue')
  },
  {
    path: '/#',
    name: 'landing',
    redirect: {name: 'dashboard'},
    meta: {requiresAuth: true},
    component: () => import('../views/layout/RouteViewContainer.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard/Dashboard.vue'),
      },
      {
         path: '/transactions',
         name: 'transactions',
         props: true,
         redirect: {name: 'transactionsList'},
         children: [
             {
                 path: 'list',
                 name: 'transactionsList',
                 props: true,
                 component: () => import('../views/transactions/TransactionsListing.vue'),
             },
             {
                 path: ':code',
                 name: 'transactionEntry',
                 props: true,
                 component: () => import('../views/transactions/TransactionDetails.vue'),
             },
         ]
      },
        {
            path: '/inventory-adjustment',
            name: 'inventoryAdjustment',
            props: true,
            redirect: {name: 'inventoryAdjustmentList'},
            children: [
                {
                    path: 'list',
                    name: 'inventoryAdjustmentList',
                    props: true,
                    component: () => import('../views/transactions/InventoryAdjustmentListing.vue'),
                },
                {
                    path: ':code',
                    name: 'inventoryAdjustmentEntry',
                    props: true,
                    component: () => import('../views/transactions/InventoryAdjustmentDetails.vue'),
                },
            ]
        },
        {
            path: '/sales-transaction',
            name: 'salesTransaction',
            component: () => import('../views/transactions/sales/SalesTransaction.vue'),
        },
        {
            path: '/stocks',
            name: 'stocks',
            props: true,
            redirect: {name: 'stocksList'},
            children: [
                {
                    path: 'list',
                    name: 'stocksList',
                    props: true,
                    component: () => import('../views/transactions/stocks/StocksListing.vue'),
                },
                {
                    path: ':code',
                    name: 'stocksForm',
                    props: true,
                    component: () => import('../views/transactions/stocks/StocksDetails.vue'),
                },
            ]
        },
        {
            path: '/waste',
            name: 'waste',
            props: true,
            redirect: {name: 'wasteList'},
            children: [
                {
                    path: 'list',
                    name: 'wasteList',
                    props: true,
                    component: () => import('../views/transactions/waste/WasteListing.vue'),
                },
                {
                    path: ':code',
                    name: 'wasteForm',
                    props: true,
                    component: () => import('../views/transactions/waste/WasteDetails.vue'),
                },
            ]
        },
        {
            path: '/store-inventory',
            name: 'storeInventory',
            redirect: {name: 'storeInventoryList'},
            children: [
                {
                    path: 'list',
                    name: 'storeInventoryList',
                    props: true,
                    component: () => import('../views/transactions/store-inventory/StoreInventoryListing.vue'),
                },
                {
                    path: ':code',
                    name: 'storeInventoryDetails',
                    props: true,
                    component: () => import('../views/transactions/store-inventory/StoreInventoryDetails.vue'),
                },
            ]
        },
        {
            path: '/inventory-adjustments',
            name: 'inventoryAdjustmentsPage',
            redirect: {name: 'inventoryAdjustments'},
            children: [
                {
                    path: 'list',
                    name: 'inventoryAdjustments',
                    props: true,
                    component: () => import('../views/transactions/inventory-adjustments/InvAdjustmentListing.vue'),
                },
                {
                    path: ':code',
                    name: 'inventoryAdjustmentsDetails',
                    props: true,
                    component: () => import('../views/transactions/inventory-adjustments/InvAdjusmentDetails.vue'),
                },
            ]
        },
      {
         path: '/petty-cash',
         name: 'pettyCash',
         component: () => import('../views/transactions/PettyCash.vue'),
      },
        {
            path: '/sales',
            name: 'sales',
            component: () => import('../views/reports/Sales.vue'),
        },
      {
         path: '/inventory',
         name: 'inventory',
         component: () => import('../views/reports/Inventory.vue'),
      },
        {
            path: '/transaction-reports',
            name: 'transactionReports',
            component: () => import('../views/reports/transaction-reports/TransactionReports.vue'),
        },
      {
         path: '/daily-reports',
         name: 'dailyReports',
         component: () => import('../views/reports/daily-reports/DailyReports.vue'),
      },
      {
         path: '/funds',
         name: 'fundsModule',
         component: () => import('../views/reports/Inventory.vue'),
      },
      {
          path: '/suppliers',
          name: 'suppliers',
          component: () => import('../views/setup/entities/Entities.vue'),
      },
        {
            path: '/supplies-category',
            name: 'suppliesCategory',
            component: () => import('../views/setup/items/supplies-category/ItemCategory.vue'),
        },
      {
          path: '/supply-types',
          name: 'supplyTypes',
          component: () => import('../views/setup/items/supply-types/SupplyTypes.vue'),
      },
        {
            path: '/items',
            name: 'items',
            component: () => import('../views/setup/items/items/Items.vue'),
        },
        {
            path: '/transaction-reasons',
            name: 'reasons',
            component: () => import('../views/setup/transaction-reasons/Reasons.vue'),
        },
        {
            path: '/item-recipes',
            name: 'itemRecipes',
            component: () => import('../views/setup/items/recipes/Recipes.vue'),
        },
      {
         path: '/profile',
         name: 'profile',
         component: () => import('../views/setup/profile/Profile.vue'),
      },
        {
            path: '/users',
            name: 'users',
            redirect: {name: 'usersList'},
            component: () => import('../views/setup/users/Users.vue'),
            children: [
                {
                    path: 'list',
                    name: 'usersList',
                    component: () => import('../views/setup/users/UsersList.vue'),
                },
                {
                    path: ':code',
                    name: 'userDetails',
                    props: true,
                    component: () => import('../views/setup/profile/ProfileForm.vue'),
                },
            ]
        },
    ]
  },
  {
        path: '/error',
        name: 'errorPage',
        component: () => import('../views/misc/ErrorEncountered.vue'),
    },
  {
    path: '/:pathMatch(.*)*',
    name: 'Page404',
    component: () => import('../views/misc/PageNotFound.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async(to, from, next) => {
    const authStore = useAuthStore()
    const isLoggedIn = authStore.isLoggedIn

    if (to.meta.requiresAuth && !isLoggedIn) {
        authStore.clearAuth()
        return next({ name: 'login' })
    }

    if(isLoggedIn) {
        if(to.name === 'login') return next({name: 'dashboard'})
        else {
            let module = to?.matched[1]?.name ?? null
            if(module) {
                // NOTE: parent of route is being get as the structure of the router is not nested
                let module_parent = getRouteParent(module)
                let permission_route_code = ROUTES_EQUIVALENT_PERM_CODE[module] ?? null
                // check if parent of route being navigated to is accessible by the user
                if(module_parent && !authStore.getAccess('module', module_parent)) return next({name: 'dashboard'})
                else if(permission_route_code && !authStore.getAccess('fn', permission_route_code, 'view')) {
                    return next({name: 'dashboard'})
                }
            }
            return next()
        }
        return next()
    }
    return next()
})

function getRouteParent(routeName) {
    for(const key of Object.keys(ROUTES_PARENT)) {
        if(ROUTES_PARENT[key].includes(routeName)) return key
    }

    return null
}

export default router
